/** @format */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Promise from 'bluebird';
import Fab from '@material-ui/core/IconButton';
import Zoom from '@material-ui/core/Zoom';
import ForwardIcon from '@material-ui/icons/ForwardTwoTone';
import InputAdornment from '@material-ui/core/InputAdornment';
import { API, Auth } from 'aws-amplify';
import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyle = makeStyles({
  root: {
    padding: 20,
    paddingTop: 30,
    minWidth: 200
  },
  error: {
    color: 'red'
  },
  input: {
    fontWeight: 'bold',
    fontSize: 30,
    width: 200
  },
  iconButton: {
    padding: 10
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4
  }
});
export default function LoginCode() {
  const classes = useStyle();
  const [state, setState] = React.useState({
    shown: false,
    code: null,
    loading: false,
    error: null
  });
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    setState(oldState => ({ ...oldState, shown: true }));
    Promise.delay(500).then(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    });
  }, []);
  const login = React.useCallback(async () => {
    try {
      setState(oldState => ({ ...oldState, loading: true }));
      const res = await API.post('cmiLoginByCode', '/code', {
        headers: { 'Content-Type': 'application/json' },
        body: {
          code: state.code
        }
      });
      const attribs = get(res, 'userList.Users.0.Attributes', []);
      const attrByKey = keyBy(attribs, 'Name');
      const result = await Auth.signIn(attrByKey.email.Value, attrByKey.given_name.Value);
      if (result && result.username) {
        window.location.reload();
        return;
      }
    } catch (err) {
      console.error(err.message);
      setState(oldState => ({ ...oldState, error: 'Not Authorized' }));
    } finally {
      setState(oldState => ({ ...oldState, loading: false }));
    }
  }, [state.code]);
  return (
    <Zoom in={state.shown}>
      <Paper data-testid="codeLogIn" className={classes.root}>
        <TextField
          variant="outlined"
          inputRef={inputRef}
          className={classes.input}
          label="Member Code"
          disabled={state.loading}
          value={state.code || ''}
          onKeyPress={ev => {
            if (ev.key === 'Enter') {
              login();
            }
          }}
          onChange={e => {
            const value = e.target.value || '';
            setState(oldState => ({ ...oldState, code: value.toUpperCase() }));
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {state.loading ? (
                  <CircularProgress />
                ) : (
                  <Fab
                    disabled={!state.code}
                    variant="round"
                    className={classes.iconButton}
                    onClick={login}>
                    <ForwardIcon />
                  </Fab>
                )}
              </InputAdornment>
            )
          }}
        />
        {!!state.error && <div className={classes.error}>{state.error}</div>}
      </Paper>
    </Zoom>
  );
}
